module.exports = __webpack_public_path__ + "static/img/flag.45078e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag.png
// module id = PNZl
// module chunks = 1